import React from 'react'
import { useDrag, useDrop } from 'react-dnd'

import ButtonController from 'common/builder/controllers/builder/Button'
import SortableGroups from 'constants/SortableGroups'
import { getCGTOnboarding } from 'utils/services/newOnboardingService'
import OnboardingPixelMount from 'utils/services/newOnboardingService/view/OnboardingPixelMount/OnboardingPixelMount'

import { DragItem } from './types'

interface SortableButtonProps {
  builderId: string
  buttonId: string
  className: string
  readonly: boolean
  rounded: boolean
  mini: boolean
  last: boolean
  first: boolean
  btnRefClassName: string | undefined
  isFallback: boolean
  onMoveButton: (buttonId: string, targetButtonId: string) => void
}

export const SortableButton = ({
  builderId,
  buttonId,
  className,
  readonly,
  rounded,
  mini,
  last,
  first,
  btnRefClassName,
  isFallback,
  onMoveButton,
}: SortableButtonProps) => {
  const ref = React.useRef<HTMLDivElement>(null)
  const [{ isDragging }, drag, preview] = useDrag(() => ({
    item: { buttonId },
    type: SortableGroups.BUTTON_LIST,
    collect: (monitor) => ({
      isDragging: monitor.isDragging(),
    }),
  }))

  const [{ canDrop }, drop] = useDrop<DragItem, void, { canDrop: boolean }>(() => ({
    accept: SortableGroups.BUTTON_LIST,
    hover: (item) => {
      if (item.buttonId !== buttonId) {
        onMoveButton(item.buttonId, buttonId)
      }
    },
  }))

  drop(preview(ref))

  return (
    <div data-onboarding-id="sortable-button" ref={ref}>
      <ButtonController
        isFallback={isFallback}
        className={className}
        btnRefClassName={btnRefClassName}
        builderId={builderId}
        buttonId={buttonId}
        rounded={rounded}
        mini={mini}
        last={last}
        first={first}
        readonly={readonly}
        dragHolder={drag}
        isDragging={isDragging}
        disableHover={canDrop}
      />
      <OnboardingPixelMount
        onMount={() => {
          getCGTOnboarding()?.steps.STEP_3?.process()
        }}
      />
    </div>
  )
}
